import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_SCORING_CATEGORIES_QUERY = gql`
  query pagedScoringCategories($pager: PagerInputNew, $filters: ScoringCategoriesFilterInput) {
    pagedScoringCategories(pager: $pager, filters: $filters) {
      total
      values {
        ...scoringCategory
      }
    }
  }
  ${Fragments.scoringCategory}
`;
